// Arabic locale. Mirrors `en.ts` key-for-key. Strings are translated, not
// transliterated. Punctuation uses Arabic-aware forms where natural; technical
// labels (file extensions, etc.) stay in their canonical form.

export default {
    brand: {
        short:   'EIT',
        full:    'الدولية المصرية لتنمية السياحة',
        tagline: 'بوابة الملاك',
    },
    common: {
        signIn:   'تسجيل الدخول',
        signOut:  'تسجيل الخروج',
        cancel:   'إلغاء',
        save:     'حفظ التغييرات',
        send:     'إرسال',
        upload:   'رفع',
        back:     'رجوع',
        loading:  'جارٍ التحميل…',
        retry:    'حاول مجددًا',
        download: 'تنزيل',
        copy:     'نسخ',
        copied:   'تم النسخ',
        yes:      'نعم',
        no:       'لا',
        and:      'و',
        language: 'اللغة',
    },
    nav: {
        dashboard:  'الرئيسية',
        statement:  'كشف الحساب',
        upload:     'رفع مستند',
        profile:    'الملف الشخصي',
        units:      'الوحدات',
    },
    auth: {
        emailLabel:     'البريد الإلكتروني',
        passwordLabel:  'كلمة المرور',
        rememberMe:     'تذكرني',
        forgotPassword: 'هل نسيت كلمة المرور؟',
        signInCta:      'تسجيل الدخول',
        signingIn:      'جارٍ تسجيل الدخول…',
        landing: {
            title:  'منزلك على البحر الأحمر، بنظرة واحدة.',
            sub:    'بوابة خاصة لملاك ومستثمري الشركة الدولية المصرية لتنمية السياحة.',
            secure: 'وصول مشفّر — حساب واحد لكل عميل.',
        },
        activate: {
            title:   'اختر كلمة المرور',
            sub:     'اختر كلمة المرور لتفعيل حسابك. سيتم تسجيل دخولك تلقائيًا.',
            newPw:   'كلمة مرور جديدة',
            confirm: 'تأكيد كلمة المرور',
            cta:     'تفعيل الحساب',
        },
        forgot: {
            title: 'إعادة تعيين كلمة المرور',
            sub:   'أدخل بريدك الإلكتروني، وسنرسل لك رابط إعادة التعيين إن وُجد الحساب.',
            cta:   'إرسال رابط إعادة التعيين',
            sent:  'إذا كان البريد مسجلاً لدينا فقد تم إرسال رابط إعادة التعيين.',
        },
        reset: {
            title:   'اختر كلمة مرور جديدة',
            cta:     'تحديث كلمة المرور',
            updated: 'تم تحديث كلمة المرور. يمكنك تسجيل الدخول الآن.',
        },
        errors: {
            badCredentials:    'البريد الإلكتروني أو كلمة المرور غير صحيحين.',
            locked:            'تم قفل الحساب مؤقتًا. حاول لاحقًا أو أعد تعيين كلمة المرور.',
            noActiveContract:  'لا توجد عقود نشطة — الوصول مرفوض.',
            suspended:         'الحساب موقوف. يرجى التواصل معنا.',
            tokenInvalid:      'الرابط غير صالح أو منتهي الصلاحية.',
            passwordTooShort:  'يجب ألا تقل كلمة المرور عن ٨ أحرف.',
            unknown:           'حدث خطأ غير متوقع. حاول مجددًا.',
            passwordsMismatch: 'كلمتا المرور غير متطابقتين.',
        },
    },
    units: {
        switcherLabel: 'الوحدة النشطة',
        selectFirst:   'اختر وحدة للمتابعة.',
        empty:         'لا توجد وحدات نشطة.',
    },
    dashboard: {
        balanceHeading: 'الرصيد الحالي',
        asOf:           'حتى {{when}}',
        multiCurrency:  'متعدد العملات',
        recent:         'آخر الحركات',
        viewStatement:  'عرض الكشف الكامل',
        uploadProof:    'رفع إثبات دفع',
        noActivity:     'لا توجد حركات بعد.',
        sharedAccount:  'يشمل هذا الكشف {{n}} وحدات تحت حساب واحد.',
    },
    statement: {
        title:        'كشف الحساب',
        rangeLabel:   'الفترة',
        last30:       'آخر ٣٠ يوم',
        last90:       'آخر ٩٠ يوم',
        ytd:          'منذ بداية العام',
        all:          'كل الفترات',
        col_num:      '#',
        col_date:     'التاريخ',
        col_desc:     'البيان',
        col_dbt:      'مدين',
        col_cdt:      'دائن',
        col_balance:  'الرصيد',
        opening:      'الرصيد الافتتاحي',
        closing:      'الرصيد الختامي',
        downloadPdf:  'تنزيل PDF',
        empty:        'لا توجد حركات في هذه الفترة.',
    },
    upload: {
        title:       'رفع إثبات دفع',
        sub:         'إيصالات تحويل بنكي، أو أي مستند يثبت الدفع. يطّلع عليه فريق EIT فقط.',
        fileLabel:   'الملف',
        notesLabel:  'ملاحظات (اختياري)',
        pickFile:    'اختر ملفًا',
        dropHere:    'أفلت الملف هنا أو انقر للاختيار.',
        limits:      'PDF أو JPEG أو PNG أو WebP — حتى ١٠ ميجابايت.',
        cta:         'إرسال',
        success:     'تم استلام الملف بنجاح.',
        tooLarge:    'حجم الملف يتجاوز ١٠ ميجابايت.',
        unsupported: 'نوع الملف غير مقبول.',
    },
    profile: {
        title:           'الملف الشخصي',
        readonly:        'قراءة فقط',
        editable:        'قابل للتعديل',
        photos:          'صور إثبات الهوية',
        fullName:        'الاسم الكامل',
        email:           'البريد الإلكتروني',
        idNo:            'الرقم القومي',
        psNo:            'رقم جواز السفر',
        tel:             'الهاتف',
        adrs:            'العنوان',
        nationality:     'الجنسية',
        dob:             'تاريخ الميلاد',
        photo:           'الصورة الشخصية',
        nationalId:      'صورة بطاقة الهوية',
        passport:        'صورة جواز السفر',
        replace:         'استبدال',
        uploadImage:     'رفع صورة',
        imageLimits:     'JPEG أو PNG أو WebP — حتى ١٠ ميجابايت.',
        changePassword:  'تغيير كلمة المرور',
        currentPassword: 'كلمة المرور الحالية',
        newPassword:     'كلمة مرور جديدة',
        confirmPassword: 'تأكيد كلمة المرور الجديدة',
        saved:           'تم الحفظ.',
    },
    a11y: {
        skipToContent: 'تخطّي إلى المحتوى',
        menu:          'القائمة',
    },
};
